export const FirebaseConfig = {
    apiKey: "AIzaSyDKif9Rj8kgtLMBhjU48BJ0T0DL95EU6nY",
    authDomain: "itnbusiness-618d5.firebaseapp.com",
    databaseURL: "https://itnbusiness-618d5.firebaseio.com",
    projectId: "itnbusiness-618d5",
    storageBucket: "itnbusiness-618d5.appspot.com",
    messagingSenderId: "789604222302",
    appId: "1:789604222302:web:c8b85f2fb1625373cefbcf",
    measurementId: "G-FV00SSG89R"
};
export const FirebaseConfig_old = {
  apiKey: "AIzaSyBqSPE2zGIM6WFKO7ODd4oSZSscvI9eo1I",
  authDomain: "whatsupbusiness.firebaseapp.com",
  databaseURL: "https://whatsupbusiness.firebaseio.com",
  projectId: "whatsupbusiness",
  storageBucket: "whatsupbusiness.appspot.com",
  messagingSenderId: "53459912104",
  appId: "1:53459912104:web:eecf33a68585a67499099d"
};
export const FirebaseConfig_181 = {
  apiKey: "AIzaSyC4WK0QNahwqWzuChSa746ueqMl6WXDra0",
  authDomain: "segup181.firebaseapp.com",
  databaseURL: "https://segup181.firebaseio.com",
  projectId: "segup181",
  storageBucket: "segup181.appspot.com",
  messagingSenderId: "444999776093",
  appId: "1:444999776093:web:fed51028443500ca1f5ab4",
  measurementId: "G-5FYRJJYGKY"
};


// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/firebase/firebase.config.ts